import type {
  AgentMatch,
  AgentRule,
  ProviderConfig,
} from "@/lib/types/itsm-config";

/** A don't-act rule must name something, as the backend requires: a
 *  catch-all one only restates what an unmatched ticket already gets. */
export function ruleNarrows(match: AgentMatch | null | undefined): boolean {
  return Boolean(
    match?.issue_type ||
      match?.external_issue_type ||
      match?.catalog_item_id ||
      match?.provider_scope,
  );
}

/** Whether a rule is a don't-act rule that narrows nothing. */
export function isInvalidAgentRule(rule: AgentRule): boolean {
  return rule.act === false && !ruleNarrows(rule.match);
}

/** Rules, when there are some, of which none has the agent act: the agent
 *  then works nothing, since unmatched tickets are left alone. */
export function agentActsOnNothing(rules: AgentRule[] | null | undefined): boolean {
  return Boolean(rules?.length) && !rules?.some((r) => r.act !== false);
}

/** The save-blocking problem with the draft's agent rules, or null. */
export function agentSaveError(draft: ProviderConfig): string | null {
  const rules = draft.agent?.rules ?? [];
  const index = rules.findIndex(isInvalidAgentRule);
  if (index === -1) return null;
  return (
    `AI agent: rule ${index + 1} skips tickets but names no type, ` +
    "item or scope."
  );
}
